import { LOCKUP_PAD_MAX, LOCKUP_PAD_MIN, LockupInsets } from './trimLogoCanvas';

export const ICON_DROP_LOCKUP_PAD_FIELDS = {
  studio: {
    top: 'iconDropStudioLockupPadTop',
    right: 'iconDropStudioLockupPadRight',
    bottom: 'iconDropStudioLockupPadBottom',
    left: 'iconDropStudioLockupPadLeft',
  },
  game: {
    top: 'iconDropGameLockupPadTop',
    right: 'iconDropGameLockupPadRight',
    bottom: 'iconDropGameLockupPadBottom',
    left: 'iconDropGameLockupPadLeft',
  },
} as const;

export type IconDropLockupPadKind = keyof typeof ICON_DROP_LOCKUP_PAD_FIELDS;
export type IconDropLockupPadKey =
  (typeof ICON_DROP_LOCKUP_PAD_FIELDS)[IconDropLockupPadKind][keyof LockupInsets];

export const ZERO_LOCKUP_INSETS: LockupInsets = { top: 0, right: 0, bottom: 0, left: 0 };

/** Empty / missing theme fields mean no extra lockup pad. */
export const parseLockupPadPercent = (value: unknown): number => {
  if (typeof value !== 'number' || !Number.isFinite(value)) return 0;
  return Math.min(LOCKUP_PAD_MAX, Math.max(LOCKUP_PAD_MIN, value));
};

export const resolveIconDropLockupInsets = (
  theme: Partial<Record<string, unknown>> | undefined,
  kind: IconDropLockupPadKind,
): LockupInsets => {
  const keys = ICON_DROP_LOCKUP_PAD_FIELDS[kind];
  if (!theme) return { ...ZERO_LOCKUP_INSETS };
  return {
    top: parseLockupPadPercent(theme[keys.top]),
    right: parseLockupPadPercent(theme[keys.right]),
    bottom: parseLockupPadPercent(theme[keys.bottom]),
    left: parseLockupPadPercent(theme[keys.left]),
  };
};

export const hasLockupInsets = (insets: LockupInsets): boolean =>
  insets.top !== 0 || insets.right !== 0 || insets.bottom !== 0 || insets.left !== 0;
